module.exports = __webpack_public_path__ + "images/emails/signatures/nathan-52e71b00fc691e5163d0cce98444e6fd.jpg";